module.exports = __webpack_public_path__ + "static/media/Economist_Logo.5964f3b0.svg";